/* tslint:disable */
/* eslint-disable */
/**
 * The Thing API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface ProductionInfoView
 */
export interface ProductionInfoView {
    /**
     * 
     * @type {Array<string>}
     * @memberof ProductionInfoView
     */
    hiddenCaseFiles?: Array<string> | null;
    /**
     * 
     * @type {boolean}
     * @memberof ProductionInfoView
     */
    useLetterBasedExhibits?: boolean;
}

export function ProductionInfoViewFromJSON(json: any): ProductionInfoView {
    return ProductionInfoViewFromJSONTyped(json, false);
}

export function ProductionInfoViewFromJSONTyped(json: any, ignoreDiscriminator: boolean): ProductionInfoView {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'hiddenCaseFiles': !exists(json, 'hiddenCaseFiles') ? undefined : json['hiddenCaseFiles'],
        'useLetterBasedExhibits': !exists(json, 'useLetterBasedExhibits') ? undefined : json['useLetterBasedExhibits'],
    };
}

export function ProductionInfoViewToJSON(value?: ProductionInfoView | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'hiddenCaseFiles': value.hiddenCaseFiles,
        'useLetterBasedExhibits': value.useLetterBasedExhibits,
    };
}


